module.exports = __webpack_public_path__ + "img/para.72da961f.svg";